import SymbolHandler from './SymbolHandler';
export default SymbolHandler;